import * as apiModule from './backend/clients.gen';
import * as schemaModule from './backend/clients.gen.schemas';

// Initialize refundsApi object if it doesn't exist
window.refundsApi = window.refundsApi || {};

for (const key in apiModule) {
  // @ts-ignore: Ignore TypeScript error for dynamic property access, its type doesn't really matter here
  const exported = apiModule[key];

  // export the typed client to the global refundsApi object so it can be used in the browser
  if (typeof exported === 'function') {
    window.refundsApi[key] = exported;
  }
}

// Initialize refundsSchema object if it doesn't exist
window.refundsSchema = window.refundsSchema || {};

for (const key in schemaModule) {
  // @ts-ignore: Ignore TypeScript error for dynamic property access, its type doesn't really matter here
  const exported = schemaModule[key];

  // export the typed schema object to the global refundsSchema object so it can be used in the browser
  if (typeof exported === 'object') {
    window.refundsSchema[key] = exported;
  }
}
